export const getCardinal = () => {
  const cardinal = (window as any).Cardinal;
  if (!cardinal) {
    throw { source: 'Cardinal is not available', data: null };
  }
  return cardinal;
};

export const startSetupCardinal = (jwt: string) => {
  const cardinal = getCardinal();
  cardinal.configure({ logging: { level: 'off' } });
  cardinal.setup('init', { jwt });
  return cardinal;
};
